/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc
 */
import * as References from './AgentGeneratedLandingPagesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc#fetch
 */
export const FETCH_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_AgentGeneratedLandingPagesRpc_fetch';
export const FETCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_QUERY_FIELD_NAME,
  args: ['offset', 'limit'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.fetchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc#fetchByAgentExecutionAndInstanceId
 */
export const FETCH_BY_AGENT_EXECUTION_AND_INSTANCE_ID_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_AgentGeneratedLandingPagesRpc_fetchByAgentExecutionAndInstanceId';
export const FETCH_BY_AGENT_EXECUTION_AND_INSTANCE_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_BY_AGENT_EXECUTION_AND_INSTANCE_ID_QUERY_FIELD_NAME,
  args: ['agentExecutionId', 'agentInstanceId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.fetchByAgentExecutionAndInstanceIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc#save
 */
export const SAVE_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_AgentGeneratedLandingPagesRpc_save';
export const SAVE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SAVE_QUERY_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.saveRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc#dismiss
 */
export const DISMISS_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_AgentGeneratedLandingPagesRpc_dismiss';
export const DISMISS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DISMISS_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.dismissRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});